import React from 'react';
import { Loader2 } from 'lucide-react';

/*
 * Empty, loading, and unmeasured states.
 *
 * The guide's empty-state contract is why nothing is shown plus the one safe
 * action available. `NotMeasured` is the honest form for an evidence surface
 * that has no reviewed data yet: it says so in place of the number rather than
 * rendering a zero, because a zero reads as a measured result.
 */

export const EmptyState: React.FC<{
  title: string;
  reason: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}> = ({ title, reason, action, className = '' }) => (
  <div className={`px-6 py-10 text-center ${className}`}>
    <div className="text-[14px] font-semibold text-ink">{title}</div>
    <p className="mx-auto mt-1.5 max-w-[46ch] text-[13px] leading-[21.5px] text-ink-dim">{reason}</p>
    {action && <div className="mt-4 flex justify-center">{action}</div>}
  </div>
);

export const NotMeasured: React.FC<{ reason?: string; className?: string }> = ({
  reason = 'Not measured yet', className = '',
}) => <span className={`font-sans text-[15px] font-normal text-ink-soft ${className}`}>{reason}</span>;

export const Loading: React.FC<{ label?: string; className?: string }> = ({
  label = 'Loading', className = '',
}) => (
  <div className={`flex items-center justify-center gap-2 py-12 text-[13px] text-ink-dim ${className}`}>
    <Loader2 size={16} className="animate-spin" />
    {label}
  </div>
);

export const ErrorNote: React.FC<{ message: string; className?: string }> = ({ message, className = '' }) => (
  <div className={`rounded-act border border-danger/25 bg-danger-soft px-4 py-3 text-[13px] text-danger ${className}`}>
    {message}
  </div>
);
